import React from 'react';

import rightArrow from '../../images/right-arrow-trp-blue.svg';
import styles from './TransferSectional.css';

const TransferSectional = () => (
    <div className="transfer-sectional">
        <h2 className="sectional-header">
            Or move an existing eligible account
        </h2>
        <span className="sectional-contents">
            Transfer or rollover assets from an account such as an IRA, 401(k)
            or College Savings from another institution.
        </span>
        <a
            href="/personal-investing/account-finder/transfers.html"
            className="trans-link"
        >
            Start a Transfer <img src={rightArrow} alt="Right Arrow" />
        </a>
        <style jsx>{styles}</style>
    </div>
);

export default TransferSectional;
